<kendo-dialog
  title="{{isEdit ? 'Зміна персональних даних' : 'Ідентифікація'}}"
  *ngIf="form"
  (close)="cancel()"
  autoFocusedElement="#lastName"
  [width]="450"
>
  <div class="example" >
    <form class="k-form" [formGroup]="form">
      <fieldset class="k-form-fieldset">

        <legend *ngIf="errMessage" class="k-form-legend" style="color:red;">{{errMessage}}</legend>

        <input type="hidden" formControlName="patientId" />

        <kendo-formfield>
          <kendo-label [for]="lastName" text="Прізвище"></kendo-label>
          <kendo-textbox
            formControlName="lastName"
            [clearButton]="true"
            #lastName
            required
          ></kendo-textbox>
          <kendo-formerror>Обов'язкове поле</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="firstName" text="Ім'я"></kendo-label>
          <kendo-textbox
            formControlName="firstName"
            [clearButton]="true"
            #firstName
            required
          ></kendo-textbox>
          <kendo-formerror>Обов'язкове поле</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield *ngIf="isEdit">
          <kendo-label [for]="patronymic" text="По батькові"></kendo-label>
          <kendo-textbox
            formControlName="patronymic"
            [clearButton]="true"
            #patronymic
          ></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="phone1" text="Телефон"></kendo-label>
          <kendo-maskedtextbox
            formControlName="phone1"
            #phone1
            required
            pattern="[0-9]{10}"
            mask="+38 0000000000"
          ></kendo-maskedtextbox>
          <kendo-formerror>Обов'язкове поле, 10 цифр</kendo-formerror>
        </kendo-formfield>

        <kendo-dialog-actions [layout]="'end'">
          <div class="k-form-buttons">
            <button kendoButton themeColor="primary" [disabled]="form.invalid" (click)="save()">Так</button>
            <button kendoButton (click)="cancel()">Ні</button>
          </div>
        </kendo-dialog-actions>
      </fieldset>
    </form>
  </div>
</kendo-dialog>